import { cn } from '../../utils/cn'

export function DialogHeader({ className, ...props }: DialogHeader.Props) {
  return <div className={cn('-mt-1 flex flex-col gap-1', className)} {...props} />
}

export namespace DialogHeader {
  export interface Props extends React.ComponentProps<'div'> {}
}
